// import React from 'react'
// import { Select, Space, DatePicker } from 'antd';
// import styled from 'styled-components/macro';

// function FilterDatePicker(props) {
//     console.log("props",props)
//     const onChange = (date, dateString) => {
//         props.setState((prevState)=> {
//             return {
//                 ...prevState,
//                 filter_value : props?.filter_value,
//                 [props.name]: date
//             }
//         })
//       };

// // const disabledDate = (current) => {
// //     return props.minDate ? current && current < props.minDate.startOf("day") : false;
// //   };


// const disabledDate = (current) => {
//     if (props.name === "from_date") {
//         // Disable dates AFTER the selected `to_date`
//         return props.maxDate ? current && current > props.maxDate.endOf("day") : false;
//     } else if (props.name === "to_date") {
//         // Disable dates BEFORE the selected `from_date`
//         return props.minDate ? current && current < props.minDate.startOf("day") : false;
//     }
//     return false;
// };

//   return (
//     <SpaceItem wrap>
//         <DateItem size="large" format="YYYY-MM-DD" placeholder='DD MM YYYY'
//          onChange={(date, dateString)=> onChange(date, dateString,props.name)} 
//         disabledDate={props.name === "to_date" ? disabledDate : undefined} // Apply only to "To Date"
//         disabled={props.name === "to_date" && !props.minDate} 
//          />
         
//     </SpaceItem>
//   )
// }

// export default FilterDatePicker


import React from 'react';
import {Select, Space, DatePicker } from 'antd';
import styled from 'styled-components/macro';

function FilterDatePicker(props) {
    

    const onChange = (date) => {
        props.setState((prevState) => ({
            ...prevState,
            filter_value: props?.filter_value,
            [props.name]: date
        }));
    };

    // Function to disable dates
    const disabledDate = (current) => {
        if (props.name === "from_date") {
            // Disable dates AFTER the selected `to_date`
            return props.maxDate ? current && current > props.maxDate.endOf("day") : false;
        } else if (props.name === "to_date") {
            // Disable dates BEFORE the selected `from_date`
            return props.minDate ? current && current < props.minDate.startOf("day") : false;
        }
        return false;
    };

    return (
        <SpaceItem wrap>
            <DateItem
                size="large"
                format="YYYY-MM-DD"
                placeholder="DD MM YYYY"
                onChange={onChange}
                disabledDate={disabledDate}
                disabled={props.name === "to_date" && !props.minDate}
            />
        </SpaceItem>
    );
}

export default FilterDatePicker;


const SpaceItem = styled(Space)`
    position: relative;
`
const DateItem = styled(DatePicker)`
    &.ant-picker {
        border-radius: 8px !important;
        background-color: #F5F8FA !important;
        border: none !important;
        width: 135px;
    }
    input {
        color: #202020 !important;
        font-family: 'Roboto' !important;
        font-style: normal !important;
        font-weight: 700 !important;
        font-size: 12px !important;
        padding: 4px 0px !important;
        /* ::placeholder {
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 700;
            font-size: 12px;
        } */
    }

   
`


// import React from "react";
// import { Space, DatePicker } from "antd";
// import styled from "styled-components/macro";

// function FilterDatePicker(props) {
//   const onChange = (date, dateString) => {
//     props.setState((prevState) => ({
//       ...prevState,
//       filter_value: props?.filter_value,
//       [props.name]: date,
//     }));
//   };

//   // Disable dates before the selected "From Date"
//   const disabledDate = (current) => {
//     return props.minDate ? current && current < props.minDate.startOf("day") : false;
//   };

//   return (
//     <SpaceItem wrap>
//       <DateItem
//         size="large"
//         format="YYYY-MM-DD"
//         placeholder="DD MM YYYY"
//         onChange={onChange}
//         disabledDate={props.name === "to_date" ? disabledDate : undefined} // Apply only to "To Date"
//       />
//     </SpaceItem>
//   );
// }

// export default FilterDatePicker;

// const SpaceItem = styled(Space)`
//   position: relative;
// `;

// const DateItem = styled(DatePicker)`
//   &.ant-picker {
//     border-radius: 8px !important;
//     background-color: #F5F8FA !important;
//     border: none !important;
//     width: 135px;
//   }
//   input {
//     color: #A1A5B7 !important;
//     font-family: "Roboto" !important;
//     font-style: normal !important;
//     font-weight: 700 !important;
//     font-size: 12px !important;
//     padding: 4px 0px !important;
//   }
// `;
